<template>
	<!-- star -->

	<div class="homepage_wrap">
		<!-- banner图和导航栏 -->
		<!--<div class="banner_nav">-->
		<nav2></nav2>
		<!--<div :style="{width: screenwidth}">-->
		<!--<div :style="{width: screenwidth}">-->
		<div class="slider_img">
			<!-- banner -->
			<!--<div class="banner_nav">-->
			<el-carousel :height="screenheight" ref="carousel" @click.native="linkTo">
				<el-carousel-item v-for="item in sliders" :key="item.url">
				<img :src="item.url" >
				</el-carousel-item >
			</el-carousel>
			<!-- title -->
			<!--<div class="banner_title_wrap">-->
				<!--<div class="banner_title_center">-->
					<!--<p>{{ title }}</p>-->
					<!--<div>科技创新引领产业发展 <span>·</span>产教融合共育技术人才</div>-->
				<!--</div>-->
			<!--</div>-->
		</div>
		<!--</div>-->


		<div class="container">
			<h1>了解我们的产品</h1>
			<b class="watermark">PRODUCT SERVICE</b>
			<a class="title">塑造更高效的生态系统</a>


			<div class="grid-container">
				<div class="grid-item">
						<div ><img src="../assets/img/homepage/product/产品1.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品2.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品3.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品4.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品5.png" alt="" /></div>
				</div>
				<div class="grid-item">
						<div><img src="../assets/img/homepage/product/产品6.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品7.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品8.png" alt="" /></div>
						<div><img src="../assets/img/homepage/product/产品9.png" alt="" /></div>
				</div>
			</div>
		</div>

		<div class="middle">
			<h1>垂直行业解决方案</h1>
			<b class="watermark">SOLUTION</b>
			<a class="title">提供精细化高质量服务</a>
			<img src="../assets/img/homepage/解决方案.png" alt="" />
		</div>

		<div class="container1">
			<h1>核心技术优势</h1>
			<b class="watermark">ADVANTAGE</b>
			<a class="title">为客户创造最大价值</a>
			<div class="grid-container1">
				<div class="grid-item1">
					<div ><img src="../assets/img/homepage/技术优势1.png" alt="" /></div>
				</div>
				<div class="grid-item1">
					<div><img src="../assets/img/homepage/技术优势2.png" alt="" /></div>
				</div>
				<div class="grid-item1">
					<div><img src="../assets/img/homepage/技术优势3.png" alt="" /></div>
				</div>
			</div>
		</div>


		<div class="middle1">
			<h1>客户辐射全国</h1>
			<b class="watermark">CUSTOMER</b>
			<a class="title">为全国客户提供优质服务</a>
			<img src="../assets/img/homepage/客户分布.png" alt="" />
		</div>
		<!-- 最新资讯 -->
		<!--<div class="news">-->
			<!--<div class="news_cont">-->
				<!--&lt;!&ndash; left &ndash;&gt;-->
				<!--<div class="news_cont_left">-->
					<!--<h1>最新资讯</h1>-->
					<!--<div class="news_bg">-->
						<!--<div class="news_cont_left_img">-->
							<!--<img src="../assets/img/news_img1.png" alt="" />-->
						<!--</div>-->
						<!--<div class="news_cont_left_text">-->
							<!--<h1>要让学生知道，努力学习是一种责任！</h1>-->
							<!--<p>2021-05-30</p>-->
							<!--<p>-->
								<!--中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任-->
							<!--</p>-->
							<!--<p>中国预防青少年犯罪研究会的副会长...</p>-->
						<!--</div>-->
					<!--</div>-->
				<!--</div>-->
				<!--&lt;!&ndash; right &ndash;&gt;-->
				<!--<div class="news_cont_right">-->
					<!--<div class="news_cont_right_ul">-->
						<!--<ul>-->
							<!--<router-link to="/xinwen"> <li>集团新闻</li></router-link>-->

							<!--<span>|</span>-->
							<!--<li>媒体报道</li>-->
							<!--<span>|</span>-->

							<!--<li>行业资讯</li>-->
						<!--</ul>-->
					<!--</div>-->
					<!--<div class="news_cont_right_text">-->
						<!--<div-->
							<!--class="news_cont_right_text_item news_cont_right_text_hr"-->
							<!--v-for="(item, index) in newList"-->
							<!--:key="index"-->
							<!--@click="newsArticle(index)"-->
						<!--&gt;-->
							<!--<h1>{{ item.title }}</h1>-->
							<!--<p>{{ item.time }}</p>-->
							<!--<p>-->
								<!--{{ item.text }}-->
							<!--</p>-->
						<!--</div>-->
					<!--</div>-->
				<!--</div>-->
			<!--</div>-->
		<!--</div>-->
		<!--&lt;!&ndash; 集团产业 &ndash;&gt;-->
		<!--<div class="GroupIndustry">-->
			<!--<div class="GroupIndustry_cont">-->
				<!--&lt;!&ndash; 左 &ndash;&gt;-->
				<!--<div class="GroupIndustry_cont_left">-->
					<!--&lt;!&ndash; title &ndash;&gt;-->
					<!--<div class="GroupIndustry_cont_left_title">-->
						<!--<p>集团产业</p>-->
					<!--</div>-->
					<!--&lt;!&ndash; img &ndash;&gt;-->
					<!--<div class="GroupIndustry_cont_left_img_f">-->
						<!--<div-->
							<!--v-for="(item, index) in jituanList"-->
							<!--:key="index"-->
							<!--class="GroupIndustry_cont_left_img"-->
						<!--&gt;-->
							<!--<img :src="item.jituanimg" />-->
							<!--<img-->
								<!--:src="item.jituanimgyinying"-->
								<!--class="GroupIndustry_cont_left_img2"-->
							<!--/>-->
							<!--<div class="GroupIndustry_cont_left_text">-->
								<!--<span>{{ item.jituanspan }}</span>-->
								<!--<p>{{ item.jituanp }}</p>-->
							<!--</div>-->
						<!--</div>-->
					<!--</div>-->
					<!--&lt;!&ndash; right &ndash;&gt;-->
				<!--</div>-->
				<!--&lt;!&ndash; right &ndash;&gt;-->
				<!--<div class="GroupIndustry_cont_right">-->
					<!--&lt;!&ndash; title &ndash;&gt;-->
					<!--<p class="GroupIndustry_cont_right_title">更多></p>-->
					<!--<div class="GroupIndustry_cont_right_img">-->
						<!--<img src="../assets/img/jituanyou.png" alt="" />-->
						<!--<img-->
							<!--class="GroupIndustry_cont_right_img2"-->
							<!--src="../assets/img/jituanyinying.png"-->
							<!--alt=""-->
						<!--/>-->
					<!--</div>-->
					<!--<div class="GroupIndustry_cont_right_text">-->
						<!--<p>执教寒夜</p>-->
						<!--<span>校企共建专业 | 校企共建二级学院 | 校企共建产业学院</span>-->
					<!--</div>-->
				<!--</div>-->
			<!--</div>-->
		<!--</div>-->
		<!--&lt;!&ndash; 关于企业 &ndash;&gt;-->
		<!--<div class="AboutEnterprises">-->
			<!--<div class="AboutEnterprises_cont">-->
				<!--&lt;!&ndash; top &ndash;&gt;-->
				<!--<div class="AboutEnterprises_cont_top">-->
					<!--&lt;!&ndash; top_left &ndash;&gt;-->
					<!--<div class="AboutEnterprises_cont_top_left">-->
						<!--<h1>关于企业</h1>-->
						<!--<p>-->
							<!--XX集团公司是一家集金融、科技、电商、职教、幼教等为一体的集团化公司。在国家“科教兴国，金融助力”的大政策背景下，通过创新金融产品助力产业升级及国民经济转型，促进社会可持续发展；以科技创新推进智慧建设，以电商创新平台带动区域经济特色发展，以产业带动专业建设，深化产业与教育深度融合，以教育助力国家现代化建设。集团公司秉承脚踏实地、志存高远的企业精神，落实内涵建设，坚持守正创新，通过校企合作共建专业、共建二级学院、共建附属幼教机构等模式，致力于让人才更有价值，让科技、教育惠及大众，走出了一条特色化的发展道路。-->
						<!--</p>-->
						<!--<router-link to="/jituangaikuo">-->
							<!--<div class="AboutEnterprises_cont_top_left_btn">-->
								<!--<span>了解更多</span>-->
								<!--<img src="../assets/img/guanyujiantou.png" alt="" />-->
							<!--</div>-->
						<!--</router-link>-->
					<!--</div>-->
					<!--&lt;!&ndash; top_right &ndash;&gt;-->
					<!--<div class="AboutEnterprises_cont_top_right">-->
						<!--<img src="../assets/img/guanyuyou.png" alt="" />-->
						<!--<div></div>-->
					<!--</div>-->
				<!--</div>-->
				<!--&lt;!&ndash; bottom &ndash;&gt;-->
				<!--<div class="AboutEnterprises_cont_bottom">-->
					<!--<div class="AboutEnterprises_cont_bottom_item">-->
						<!--<h1>30</h1>-->

						<!--<div class="AboutEnterprises_cont_bottom_item2">-->
							<!--<span>+</span>-->
							<!--<p>全国校区</p>-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="AboutEnterprises_cont_bottom_item">-->
						<!--<h1>30</h1>-->
						<!--<div class="AboutEnterprises_cont_bottom_item2">-->
							<!--<span>+</span>-->
							<!--<p>全国校区</p>-->
						<!--</div>-->
					<!--</div>-->
					<!--<div class="AboutEnterprises_cont_bottom_item3">-->
						<!--<h1>3000</h1>-->
						<!--<div class="AboutEnterprises_cont_bottom_item4">-->
							<!--<span>+</span>-->
							<!--<p>全国校区</p>-->
						<!--</div>-->
					<!--</div>-->
					<!--<div-->
						<!--class="AboutEnterprises_cont_bottom_item"-->
						<!--style="border: 0; margin-right: -70px"-->
					<!--&gt;-->
						<!--<h1>30</h1>-->
						<!--<div class="AboutEnterprises_cont_bottom_item2">-->
							<!--<span>+</span>-->
							<!--<p>全国校区</p>-->
						<!--</div>-->
					<!--</div>-->
				<!--</div>-->
			<!--</div>-->
		<!--</div>-->
		<!--&lt;!&ndash; 合作伙伴 &ndash;&gt;-->
		<!--<div class="CooperativePartner">-->
			<!--<div class="CooperativePartner_cont">-->
				<!--<h1 class="CooperativePartner_cont_title">合作伙伴</h1>-->
			<!--</div>-->
			<!--<div class="CooperativePartner_cont_center">-->
				<!--<div class="CooperativePartner_cont_center_item">-->
					<!--<img src="../assets/img/合作1.png" alt="" />-->
					<!--<span>合作院校</span>-->
				<!--</div>-->
				<!--<div class="CooperativePartner_cont_center_item">-->
					<!--<img src="../assets/img/合作2.png" alt="" />-->
					<!--<span>合作院校</span>-->
				<!--</div>-->
			<!--</div>-->
			<!--<div class="CooperativePartner_cont_bottom">-->
				<!--<div-->
					<!--v-for="(item, index) in logoList"-->
					<!--:key="index"-->
					<!--class="CooperativePartner_cont_bottom_logo"-->
				<!--&gt;-->
					<!--<img :src="item.logo" alt="" />-->
				<!--</div>-->
			<!--</div>-->
		<!--</div>-->

		<!-- footer -->
		<footer2></footer2>

		<!-- end -->
	</div>
</template>

<script>
import nav2 from "../components/nav.vue";
import footer2 from "../components/footer.vue";
export default {
	name: "index",
	components: {
		footer2,
		nav2,
	},
	data() {
		return {
			// screenwidth:require(document.documentElement.clientWidth+'px'),
			sliders: [
				{url:require('../assets/img/homepage/banner1.png')},
				{url:require('../assets/img/homepage/banner2.png'),link:'/infoc'},
				{url:require('../assets/img/homepage/banner3.png'),link:'/govSolution'},
				],
			screenheight: document.documentElement.clientHeight + 'px',

			logoimg: require("../assets/logonew.png"),
		};
	},
	computed: {
		title() {
			return this.$store.state.title;
		},
	},
	methods: {
		homeRouter() {
			this.$router.push("/");
		},
		funyuming(msg) {
			this.$router.push(msg);
		},
		newsArticle(index) {
			this.$router.push("/newsxiangqing" + index);
		},
		funRouter() {
			this.$router.push("/keji");
		},
		serviceRouter() {
			this.$router.push("/service");
		},
		productRouter() {
			this.$router.push("/keji");
		},
		solution() {
			this.$router.push("/govSolution");
		},
		aboutUs() {
			this.$router.push("/keji");
		},
		linkTo () {
			let activeIndex = this.$refs.carousel.activeIndex
			this.$router.push(this.sliders[activeIndex].link)
		},
	},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/
/*.el-carousel {*/
/*width: 1920px;*/
/*}*/
/*.el-carousel__item:nth-child(2n) {*/
	/*background-color: #99a9bf;*/
/*}*/
/*.el-carousel__item:nth-child(2n+1) {*/
	/*background-color: #d3dce6;*/
/*}*/
/deep/ .el-carousel__indicators {
    left: 45%;
	transform: unset;
}
/deep/ .el-carousel__button {
	/*position: relative;*/
	margin-top: -15vh;
    width: 50px;
	height: 10px;
	border: none;
	/*border-radius: 50%;*/
	background-color: rgba(0, 0, 0, 0.2);
}
/deep/ .is-active .el-carousel__button {
     background: #365CE8;
}

/*/deep/ .el-carousel__container {*/
	/*height: 100%;*/
/*}*/

.watermark {
	position: relative;
	/*bottom: 10px;*/
	/*right: 10px;*/
	margin-top: -250px;
	text-align: center;
	color: #EAEEFC;
	font-size: 80px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	opacity: 0.5;
	top:120px;
	z-index: 1;
}
.title{
	position: relative;
	text-align: center;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	margin-top:-50px;
	margin-bottom: 80px;
	z-index: 3
}
.homepage_wrap {
	width: 100vm;
	margin: 0 auto;
	height: auto;
}
.slider_img {
	width: 1920px;
	height: auto;
	/*margin-top: 80px;*/
}
@media screen and (max-device-width: 1900px) {
	.slider_img {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.slider_img {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.slider_img {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.slider_img {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.slider_img {
		height: auto;
		width: 2560px;
	}
}
.container {
	position:relative;
	display: grid;
	/*background-color: #F8F9FC;*/
	width: 1920px;
	height: auto;
	margin-bottom: 80px;
	/*justify-content: space-between;*/
	/*align-items: center;*/
}

@media screen and (max-device-width: 1900px) {
	.container {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.container {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.container {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.container {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.container {
		height: auto;
		width: 2560px;
	}
}
.container img{
	width: 220px;
	height: auto;
	margin:0 auto;
	display: flex;
	justify-content: space-between;

}
.container h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	z-index: 2;
}
.grid-container {
	display: grid;
	width: 100%;
	justify-content: center;
	grid-gap: 30px;
	/*background-color: #F8F9FC;*/
	/*grid-template-columns: repeat(2, 1fr);*/
	/*grid-template-rows: repeat(2, 1fr);*/
}
.grid-item {
	display: flex;
	/*background-color: #ccc;*/
	/*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);*/
	/*background-color: #F8F9FC;*/
	color: #fff;
	width: 220px;
	justify-content: center;
	grid-gap: 30px;
	/*text-align: center;*/
	/*padding: 30px 80px;*/
}
.middle{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	justify-content: center;
	/*margin-bottom:20px;*/
}

@media screen and (max-device-width: 1900px) {
	.middle {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.middle {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.middle {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle {
		height: auto;
		width: 2560px;
	}
}
.middle img{
	width: 1200px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;
	margin-bottom: 80px;

}
.middle h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 120px;
	margin-bottom: 80px;
	z-index: 2;
}
.middle1{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	justify-content: center;
	/*margin-bottom:20px;*/
}
@media screen and (max-device-width: 1900px) {
	.middle1 {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle1 {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.middle1 {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.middle1 {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle1 {
		height: auto;
		width: 2560px;
	}
}
.middle1 img{
	width: 974px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;
	margin-bottom: 80px;

}
.middle1 h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 120px;
	margin-bottom: 80px;
	z-index: 2;
}


.container1 {
	position:relative;
	display: grid;
	/*background-color: #F8F9FC;*/
	width: 1920px;
	height: auto;
	margin-bottom: 80px;
}
@media screen and (max-device-width: 1900px) {
	.container1 {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.container1 {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.container1 {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.container1 {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.container1 {
		height: auto;
		width: 2560px;
	}
}
.container1 img{
	width: 314px;
	height: auto;
	margin:0 auto;
	display: flex;
	justify-content: space-between;

}
.container1 h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	z-index: 2;
}
.grid-container1 {
	display: flex;
	width: 100%;
	justify-content: center;
	grid-gap: 30px;
	/*background-color: #F8F9FC;*/
}
.grid-item1 {
	/*background-color: #F8F9FC;*/
	color: #fff;
	width: 314px;
}
.navWrap_center_img img {
	/*width: 181px;*/
}

.navWrap_center_ul {
	/* border:1px solid red; */
	margin-right: 121px;
}
.navWrap_center_ul li {
	display: inline-block;
	height: 98px;
	line-height: 98px;
	/* border-bottom: 4px solid blue; */
	margin-left: 50px;
	padding: 0 5px;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	/* line-height: 22px; */
}
.navWrap_center_ul li:hover {
	cursor: pointer;
	color: rgba(35, 51, 127, 1);
	border-bottom: 2px solid rgba(35, 51, 127, 1);
}


.banner_title_center div {
	padding-top: 14px;
	font-size: 20px;
	font-family: Helvetica;
	line-height: 24px;
	letter-spacing: 4px;
}

.banner_title_center div span {
	margin: 0 18px;
}
/* news */
.news {
	width: 100vw;
	height: 801px;
	background: #f8f8f8;
}
.news_cont {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}
.news_cont_left {
	margin-top: 89px;
}
.news_cont_left_img img {
	width: 588px;
	height: 353px;
	margin-top: 41px;
}
.news_cont_left_text {
	padding-top: 27px;
	padding-left: 40px;
	width: 548px;
	height: 150px;
	background-color: #ffffff;
}
.news_cont_left_text h1 {
	font-size: 18px;
	font-weight: 500;
	color: #23337f;
}
.news_cont_left_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	margin-top: 10px;
}
.news_cont_right {
	width: 588px;
	margin-top: 103px;
}
.news_cont_right_ul ul {
	font-size: 16px;
	font-weight: 400;
	color: #b3b3b3;
	line-height: 22px;
	float: right;
	display: flex;
}
.news_cont_right_ul ul a {
	font-size: 16px;
	font-weight: 400;
	color: #b3b3b3;
	line-height: 22px;
	float: right;
	display: flex;
}
.news_cont_right_ul ul li:hover {
	color: #23337f;
}
.news_cont_right_ul ul span {
	margin: 0 23px 0 24px;
}
.news_cont_right_text {
	width: 588px;
	height: 535px;
	background: #ffffff;
	margin-top: 68px;
}
.news_cont_right_text_item {
	padding: 36px;
}
.news_cont_right_text_item h1 {
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 25px;
}
.news_cont_right_text_item p {
	margin-top: 10px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	line-height: 20px;
}
.news_cont_right_text_hr {
	/* float: right; */
	width: 508px;

	border-bottom: 1px solid #d7d7d7;
}
.news_cont_right_text_hr:nth-of-type(3) {
	/* float: right; */
	width: 508px;

	border-bottom: none;
}
.news_cont_right_text_item2 {
	padding: 24px 40px;
}
.news_cont_right_text_item2 h1 {
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 25px;
}
.news_cont_right_text_item2 p {
	margin-top: 10px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	line-height: 20px;
}
/* 集团产业 */
.GroupIndustry {
	width: 100vw;
	height: 800px;
	background: #ffffff;
}
.GroupIndustry_cont {
	width: 1200px;
	margin: 0 auto;

	display: flex;
	justify-content: space-between;
}
.GroupIndustry_cont_left_title {
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #444444;
	line-height: 50px;
	margin: 84px 0 40px 0;
}
.GroupIndustry_cont_left_img_f {
	width: 793px;

	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
.GroupIndustry_cont_left_img {
	margin-bottom: 24px;

	position: relative;
}
.GroupIndustry_cont_left_img img:first-child {
	width: 384px;
	height: 261px;
	background: linear-gradient(180deg, rgba(0, 100, 255, 0) 0%, #000b6e 100%);
}
.GroupIndustry_cont_left_img2 {
	position: absolute;
	left: 0;
	bottom: 0;
}

.GroupIndustry_cont_left_text {
	position: absolute;
	left: 32px;
	bottom: 18px;
}
.GroupIndustry_cont_left_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
	margin-top: 10px;
}
.GroupIndustry_cont_left_text span {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
}
.GroupIndustry_cont_right {
	position: relative;
	margin-top: 98px;
}
.GroupIndustry_cont_right_title {
	float: right;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 22px;
	margin-bottom: 54px;
}

.GroupIndustry_cont_right_img {
	width: 384px;
	height: 546px;
}
.GroupIndustry_cont_right_img2 {
	position: absolute;
	bottom: 24px;
}
.GroupIndustry_cont_right_text {
	position: absolute;
	left: 45px;
	bottom: 45px;
}
.GroupIndustry_cont_right_text p {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	line-height: 33px;
}
.GroupIndustry_cont_right_text span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
}
/* 关于企业 */
.AboutEnterprises {
	width: 100vw;
	height: 856px;
	background-image: url("../assets/img/guanyu_bg.png");
}
.AboutEnterprises_cont {
	width: 1200px;
	margin: 0 auto;
	height: 100%;
}
.AboutEnterprises_cont_top {
	display: flex;
	justify-content: space-between;
}
.AboutEnterprises_cont_top_left {
	margin-top: 143px;
	width: 600px;
}
.AboutEnterprises_cont_top_left > h1 {
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	line-height: 50px;
}
.AboutEnterprises_cont_top_left p {
	margin-top: 36px;

	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 40px;
}
.AboutEnterprises_cont_top_left_btn {
	width: 160px;
	height: 40px;
	border: 1px solid rgba(255, 255, 255, 0.8);
	margin-top: 81px;
	display: flex;
	align-items: center;
}
.AboutEnterprises_cont_top_left_btn img {
	width: 24px;
	height: 24px;

	margin-left: 8px;
}
.AboutEnterprises_cont_top_left_btn span {
	margin-left: 32px;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 22px;
}
.AboutEnterprises_cont_top_right {
	position: relative;
	width: 487px;
	height: 517px;
	margin-top: 115px;
}
.AboutEnterprises_cont_top_right img {
	position: absolute;
	z-index: 1;
}
.AboutEnterprises_cont_top_right Div {
	width: 317px;
	height: 408px;
	background: #3491e5;
	position: absolute;
	top: 64px;
	left: -33px;
}
.AboutEnterprises_cont_bottom {
	display: flex;

	margin-top: 80px;
}
.AboutEnterprises_cont_bottom_item {
	margin-right: 70px;
	position: relative;
	width: 247px;
	border-right: 1px solid #ffffff;
	display: flex;
}
.AboutEnterprises_cont_bottom_item3 {
	margin-right: 70px;
	position: relative;
	width: 323px;
	border-right: 1px solid #ffffff;
	display: flex;
}
.AboutEnterprises_cont_bottom_item3 p {
	width: 86px;
	height: 28px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #b30588;
	line-height: 28px;
}
.AboutEnterprises_cont_bottom_item3 h1 {
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item3 span {
	font-size: 17px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #692020;
	line-height: 24px;
}
.AboutEnterprises_cont_bottom_item4 {
	position: absolute;
	left: 161px;
	bottom: 15px;
}

.AboutEnterprises_cont_bottom_item h1 {
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item span {
	font-size: 17px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #692020;
	line-height: 24px;
}
.AboutEnterprises_cont_bottom_item p {
	width: 86px;
	height: 28px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #b30588;
	line-height: 28px;
}

.AboutEnterprises_cont_bottom_item2 {
	position: absolute;
	left: 85px;
	bottom: 15px;
}
/* 合作伙伴 */
.CooperativePartner {
	width: 100vw;
	height: 798px;
	background-image: url("../assets/img/hezuo_bg.png");
}
.CooperativePartner_cont {
	width: 1200px;
	margin: 0 auto;
}
.CooperativePartner_cont_title {
	text-align: center;
	margin-top: 80px;
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #444444;
	line-height: 50px;
}
.CooperativePartner_cont_center {
	display: flex;
	justify-content: space-between;
	width: 365px;
	height: 69px;

	margin: 0 auto;
	margin-top: 47px;
}
.CooperativePartner_cont_center_item {
	display: flex;
	align-items: center;
}
.CooperativePartner_cont_center_item:hover {
	border-bottom: 1px solid #3491e5;
}
.CooperativePartner_cont_center_item img {
	width: 40px;
	height: 40px;
}
.CooperativePartner_cont_center_item span {
	line-height: 69px;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 33px;
	margin-left: 14px;
}
.CooperativePartner_cont_bottom {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 1200px;
	height: 392px;
	margin: 0 auto;
	margin-top: 80px;
}
.CooperativePartner_cont_bottom_logo img {
	width: 227px;
	height: 120px;
	background: #ffffff;
	box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
	border-radius: 9px;
	margin-bottom: 16px;
}
.dropbtn {
	font-family: AlibabaPuHuiTi-3-55-Regular;
	background-color: #fff;
	color: rgb(12, 11, 11);
	padding: 20px;
	font-size: 20px;
	border: none;
	cursor: pointer;
}
.dropbtnpic {
	content: ' '; /*必须设置content属性*/
	width: 0;
	height: 0;
	border-left: 6px solid transparent; /*左边*/
	border-right: 6px solid transparent; /*右边*/
	border-top: 6px solid #000; /*上边，箭头颜色为黑色*/
	position: absolute;
	/*right: 12px; !*调整箭头位置*!*/
	top: 50%; /*让箭头居中*/
	transform: translateY(-50%); /*向上位移50%*/
}
.dropdown {
	top: 12px;
	left: -50px;
	position: relative;
	display: inline-block;
	z-index: 99999;
}

.dropdown-content {
	text-align: center;
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 150px;
	min-height: 120px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.dropdown-content a {
	color: rgb(6, 6, 6);
	padding: 12px 16px;
	text-decoration: none;
	display: block;
}

.dropdown-content a:hover {
	background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
	display: block;
}
</style>
